import React, { Component } from 'react'
import { Card } from 'primereact/card';
import logo from './imagen/capufe02.png';
export class ImagenLogoCapufe extends Component {

  render() {
    return (
      <Card >
        <div className="p-grid">
          <div className="p-col-12 p-md-3">

          </div>
          <div className="p-col-12 p-md-6">
            <img style={{ width: '100%', height: '100%' }} src={logo} alt="logo" /></div>
        </div>
        <div className="p-col-12 p-md-3">

        </div>
      </Card>
    );

  }
}